import React, { useState } from 'react';
import { FormattedDate, FormattedNumber } from 'react-intl'
import { StyleInlineFkTable, StyledPropotionalNavLink } from '../../../../Styling/styledTable/StyledTable';
import UseTableSorter from '../../../../components/useTable/UseTable'
import usePaginator from '../../../../components/useTable/UsePaginator'
import { fixMissingTimeFromDate } from '../../../../util/date/dateRoutines';

const ExpandedKjoeretoyTable = (props) => {

    const localeMessages = props.localeMessages

    // State for grid sorting
    const [currentSeq, setCurrentSeq] = useState('up'); // default
    const [currentField, setCurrentField] = useState('j');    // feltnavn
    const [currentType, setCurrentType] = useState('datetime'); // num

    // state for grid paginator
    const [numberPrPage, setNumberPrPAge] = useState(10000)
    const [activePage, setActivePage] = useState(1);


    const [t1ChangeSortField, t1GetSortFunc, t1IndicaterIcon] = UseTableSorter(
        currentSeq, setCurrentSeq,
        currentField, setCurrentField,
        currentType, setCurrentType
    )

    // Point to data 
    const kjoeretoyData = props.tableData;


    const [Paginate, PaginationNav, PaginationDropdown, PaginationIndex, resetPagination] = usePaginator(
        kjoeretoyData.sort(t1GetSortFunc().fn), // <==== sorting inputdata =========
        numberPrPage, setNumberPrPAge,
        activePage, setActivePage
    )

    const printHeader = () => {
        return (
            <thead>
                <tr>
                    <th style={{ fontSize: 'clamp(10px, 0.65vw, 20px)' }} >Nr</th>
                    <th style={{ fontSize: 'clamp(10px, 0.65vw, 20px)' }} >DokumentNr</th>
                    <th style={{ fontSize: 'clamp(10px, 0.65vw, 20px)' }} >Type</th>
                    <th style={{ fontSize: 'clamp(10px, 0.65vw, 20px)' }} >Reg.tidspunkt</th>
                    <th style={{ fontSize: 'clamp(10px, 0.65vw, 20px)' }} >Vedtakstidspunkt</th>
                    <th style={{ fontSize: 'clamp(10px, 0.65vw, 20px)' }} >Utløpsdato for rettsvern</th>
                    <th style={{ fontSize: 'clamp(10px, 0.65vw, 20px)', textAlign: "right", paddingRight: 50 }} >Beløp</th>
                    <th style={{ fontSize: 'clamp(10px, 0.65vw, 20px)' }} >Valuta</th>
                    <th style={{ fontSize: 'clamp(10px, 0.65vw, 20px)' }} >Pantsetter Type</th>
                    <th style={{ fontSize: 'clamp(10px, 0.65vw, 20px)' }} >Pantsetter OrgId</th>
                    <th style={{ fontSize: 'clamp(10px, 0.65vw, 20px)' }} >Pantsetter Navn</th>
                    <th style={{ fontSize: 'clamp(10px, 0.65vw, 20px)' }} >Panthaver Type</th>
                    <th style={{ fontSize: 'clamp(10px, 0.65vw, 20px)' }} >Panthaver OrgId</th>
                    <th style={{ fontSize: 'clamp(10px, 0.65vw, 20px)' }} >Panthaver Navn</th>
                </tr>
            </thead>
        )
    }

    const printRow = (model) => {

        const asDate = (val) => {
            // Tomt felt om det er noe krøll med val, ellers blir dagens dato satt inn som default
            if (val === null || val === '' || val === undefined) {return (<></>)};
            // Kludge fordi FireFox ikke godtar dato uten tid uten videre
            let valok = fixMissingTimeFromDate(val)
            return (
                <FormattedDate value={valok} day="2-digit" month="2-digit" year="numeric" />
            )
        }

        return (
            <>
                <tr key={model.j + 10000} style={{ backgroundColor: 'white' }}>

                    <td>{model.j + 1}</td>
                    <td>{model.documentNumber}</td>
                    <td>{model.type}</td>
                    <td>{model.entryTimestamp}</td>
                    <td>{model.decisionTimestamp}</td>
                    <td>{model.expiryDateLegalProtection}</td>
                    <td align='right' style={{ paddingRight: 50 }}>
                        {model.amounts[0]?.amount}
                    </td>
                    <td align='right' style={{ paddingRight: 50 }}>
                        {model.amounts[0]?.currency}
                    </td>
                    <td>{model.mortagor[0]?.type}</td>
                    <td>{model.mortagor[0]?.organisationId}</td>
                    <td>{model.mortagor[0]?.name}</td>
                    <td>{model.lienHolder[0]?.type}</td>
                    <td>{model.lienHolder[0]?.organisationId}</td>
                    <td>{model.lienHolder[0]?.name}</td>
                </tr>
            </>
        )
    }

    return (
        <>

            <StyleInlineFkTable>
                {printHeader()}

                <tbody>
                    <Paginate>
                        {/* paginate forventer en funksjon */}
                        {row => printRow(row)}
                    </Paginate>
                </tbody>
            </StyleInlineFkTable>

        </>
    )
}

export default ExpandedKjoeretoyTable